import React, {
    Component
} from 'react';

import {HashRouter} from 'react-keeper';

import Login from './Login';
import Paper from './Paper';
import Register from './Register';
import Dingding from './dingding';
import EmployeePwd from './employeePwd';
import Sso from './Sso';
import Sso2 from './Sso2';
import CasLogin from './CasLogin';
import DDlogin from './DDlogin';
import License from './License';

class Root extends Component {
    constructor(props) {
        super(props);
    }

    router() {
        const url = window.location.hash;
        const props = this.props;
        if(props.session) {
            return <Paper { ...props }></Paper>
        } else {
            if(url.indexOf('/sso/login') != -1) {
                return <Sso { ...props }></Sso>
            }else if(url.indexOf('/user/register') != -1) {
                return <Register { ...props } />
            }else if(url.indexOf('/employeePwd') != -1){
                return <EmployeePwd { ...props } />
            }else if(url.indexOf('/dingding') != -1) {
                return <Dingding { ...props } />
            }else if(url.indexOf('/login2') != -1) {
                return <Sso2 { ...props }></Sso2>
            }else if(url.indexOf('/cas/login') != -1) {
                return <CasLogin { ...props }></CasLogin>
            }else if(url.indexOf('/sso/ddlogin') != -1) {
                return <DDlogin { ...props }></DDlogin>
            }else if(url.indexOf('/license') != -1) {
                return <License { ...props }></License>
            }else {
                return <Login { ...props }></Login>
            }
        }
    }

    render() {
        return (
            <HashRouter>
                {
                    this.router()
                }
            </HashRouter>
        );
    }
}

export default Root;